/* Public trip page (Cliente-20): Brasa + Carvão, Sora + Instrument Sans, mobile first. */
:root {
  --brasa: #ff6b1a;
  --brasa-ink: #1a0d04;
  --brasa-text: #c2410c;
  --ink: #15110e;
  --ink-2: #36302b;
  --text-2: #4e4740;
  --muted: #6b6259;
  --chip: #f3f0ec;
  --line: #e7e2dc;
  --page: #faf8f6;
  --ok-bg: #e8f5ee;
  --ok: #15703d;
  --ok-dot: #1f9d55;
  --bad: #b42318;
  --bad-dot: #d92d20;
  --warn-bg: #fef6e0;
  --warn: #8a5a00;
  color-scheme: light;
}
* { box-sizing: border-box; }
html, body, #root { height: 100%; }
body { margin: 0; background: var(--page); color: var(--ink); font-family: "Instrument Sans", -apple-system, system-ui, sans-serif; -webkit-font-smoothing: antialiased; }
a { color: var(--brasa-text); }
:focus-visible { outline: 2px solid var(--brasa); outline-offset: 2px; }

.page { position: relative; min-height: 100%; max-width: 560px; margin: 0 auto; display: flex; flex-direction: column; background: var(--page); }
@media (min-width: 600px) { body { background: #e4ded7; } .page { box-shadow: 0 0 40px rgba(21, 17, 14, 0.12); } }

.top { position: sticky; top: 0; z-index: 3; height: 64px; padding: 0 16px; display: flex; align-items: center; justify-content: space-between; background: #fff; border-bottom: 1px solid var(--line); }
.brand { display: flex; align-items: center; gap: 10px; }
.brand-logo { height: 22px; width: auto; display: block; }
.brand-sub { font-size: 13px; color: var(--muted); }
.live { display: flex; align-items: center; gap: 6px; height: 28px; padding: 0 10px; border-radius: 999px; background: var(--ok-bg); color: var(--ok); font-size: 12px; font-weight: 700; }
.live-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--ok-dot); animation: live 1.4s infinite; }

/* The map fills the page; the sheet floats over its bottom and --peek (set by Sheet) keeps the map above the collapsed sheet. */
.stage { position: relative; flex: 1; min-height: 440px; overflow: hidden; }
.map-area { position: absolute; inset: 0 0 calc(var(--peek, 200px) - 28px); background: #ece7e1; overflow: hidden; }
.map-svg, .map-google { position: absolute; inset: 0; width: 100%; height: 100%; }
.ping { transform-box: fill-box; transform-origin: center; animation: ping 2s ease-out infinite; }
.glass {
  background: rgba(255, 255, 255, 0.66); backdrop-filter: blur(24px) saturate(180%); -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.7); box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95), 0 10px 30px rgba(21, 17, 14, 0.16);
}
.chip-updated { position: absolute; left: 16px; top: 16px; z-index: 1; padding: 6px 12px; border-radius: 999px; font-size: 12px; font-weight: 600; color: var(--ink-2); }
.chip-recenter {
  position: absolute; right: 16px; bottom: 40px; z-index: 1; height: 36px; padding: 0 14px 0 11px; border-radius: 999px; display: flex; align-items: center; gap: 6px;
  font: inherit; font-size: 13px; font-weight: 600; color: var(--ink-2); cursor: pointer;
}
.map-svg { touch-action: none; cursor: grab; user-select: none; -webkit-user-select: none; }
.map-svg:active { cursor: grabbing; }
.chip-sos {
  position: absolute; right: 16px; top: 12px; z-index: 1; height: 36px; padding: 0 14px; border-radius: 999px; display: flex; align-items: center;
  font-family: "Sora", sans-serif; font-size: 13px; font-weight: 700; color: var(--bad); text-decoration: none;
}

.sheet {
  position: absolute; z-index: 2; left: 0; right: 0; bottom: 0; max-height: calc(100% - 24px); display: flex; flex-direction: column;
  background: #fff; border-radius: 28px 28px 0 0; box-shadow: 0 -8px 30px rgba(21, 17, 14, 0.12); will-change: transform;
}
.sheet-animate { transition: transform 0.42s cubic-bezier(0.32, 0.72, 0, 1); }
.sheet-peek { flex: none; position: relative; padding: 20px 18px 16px; display: flex; flex-direction: column; gap: 14px; }
.sheet-grab { cursor: grab; touch-action: none; user-select: none; -webkit-user-select: none; }
.sheet-grab:active { cursor: grabbing; }
/* 44px hit area around a 36×5 bar. */
.sheet-handle { position: absolute; top: 0; left: 50%; transform: translateX(-50%); width: 72px; height: 22px; padding: 0; border: 0; background: none; cursor: inherit; display: grid; place-items: center; }
.sheet-handle span { width: 36px; height: 5px; border-radius: 3px; background: var(--line); transition: background 0.15s; }
.sheet-handle:hover span { background: #cfc7be; }
.sheet-rest {
  min-height: 0; overflow-y: auto; overscroll-behavior: contain; display: flex; flex-direction: column; gap: 14px;
  padding: max(4px, env(safe-area-inset-bottom)) 18px calc(24px + env(safe-area-inset-bottom));
}
.sheet-safe { position: absolute; height: env(safe-area-inset-bottom); width: 0; visibility: hidden; }
.headline { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
.headline-text { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.lead { font-size: 14px; color: var(--muted); }
.title { font-family: "Sora", sans-serif; font-size: 21px; letter-spacing: -0.015em; line-height: 26px; overflow-wrap: anywhere; }
.eta { flex: none; display: flex; flex-direction: column; align-items: flex-end; }
.eta-value { font-family: "Sora", sans-serif; font-weight: 600; font-size: 24px; color: var(--brasa-text); font-variant-numeric: tabular-nums; }
.eta-label { font-size: 12px; color: var(--muted); }
.progress { height: 6px; border-radius: 3px; background: var(--chip); overflow: hidden; }
.progress span { display: block; height: 100%; border-radius: 3px; background: var(--brasa); transition: width 0.6s ease; }

.driver { display: flex; align-items: center; gap: 12px; padding: 12px; border-radius: 18px; background: var(--chip); }
.avatar { flex: none; width: 44px; height: 44px; border-radius: 50%; background: var(--ink-2); color: #faf8f6; display: grid; place-items: center; font-family: "Sora", sans-serif; font-weight: 600; font-size: 14px; }
.driver-text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.driver-text b { font-size: 15px; }
.driver-text > span { font-size: 12px; color: var(--text-2); }
.avatar-photo { object-fit: cover; background: var(--line); }
.verified { display: inline-grid; place-items: center; vertical-align: -3px; margin-left: 5px; padding: 0; border: 0; background: none; cursor: pointer; position: relative; }
/* A 44px target around the 16px badge, without growing the line. */
.verified::after { content: ""; position: absolute; inset: -14px; }
.check-badge { display: block; }
.nowrap { white-space: nowrap; }

.trust-dialog {
  margin: auto auto 0; width: 100%; max-width: 560px; border: 0; padding: 0; border-radius: 28px 28px 0 0; background: #fff; color: var(--ink);
  box-shadow: 0 -8px 30px rgba(21, 17, 14, 0.18);
}
.trust-dialog::backdrop { background: rgba(21, 17, 14, 0.4); }
.trust-dialog[open] { animation: sheet-in 0.32s cubic-bezier(0.32, 0.72, 0, 1); }
.trust-body { padding: 28px 22px calc(22px + env(safe-area-inset-bottom)); display: flex; flex-direction: column; align-items: center; gap: 10px; text-align: center; }
.trust-body h2 { margin: 4px 0 0; font-family: "Sora", sans-serif; font-size: 20px; letter-spacing: -0.015em; }
.trust-body p { margin: 0; font-size: 15px; line-height: 1.45; color: var(--text-2); }
.trust-body .trust-note { font-size: 13px; color: var(--muted); }
.trust-body form { width: 100%; margin-top: 8px; }
.btn-ok { width: 100%; height: 52px; border: 0; border-radius: 18px; background: var(--brasa); color: var(--brasa-ink); font: inherit; font-weight: 600; font-size: 15px; cursor: pointer; }
@keyframes sheet-in { from { transform: translateY(100%); } }

.avatar-wrap { flex: none; position: relative; padding-bottom: 6px; }
.rating {
  position: absolute; left: 50%; bottom: -2px; transform: translateX(-50%); padding: 1px 6px; border-radius: 999px; white-space: nowrap;
  background: #fff; box-shadow: 0 1px 3px rgba(21, 17, 14, 0.18); font-size: 11px; font-weight: 700; color: var(--ink-2); font-variant-numeric: tabular-nums;
}
.plate { flex: none; width: 96px; border-radius: 6px; overflow: hidden; border: 1.5px solid var(--ink); background: #fff; display: flex; flex-direction: column; }
.plate-band { height: 9px; background: #1c3f94; }
.plate-text { height: 26px; display: grid; place-items: center; font-family: "Sora", sans-serif; font-weight: 700; font-size: 15px; letter-spacing: 0.05em; }

.note { font-size: 13px; color: var(--text-2); }
.note-warn { padding: 10px 12px; border-radius: 12px; background: var(--warn-bg); color: var(--warn); font-weight: 600; }

.steps { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
.steps li { position: relative; display: flex; align-items: center; gap: 12px; padding: 7px 0; font-size: 14px; color: var(--muted); }
.steps li::before { content: ""; position: absolute; left: 6px; top: -7px; height: 14px; width: 2px; background: var(--line); }
.steps li:first-child::before { display: none; }
.steps li.done { color: var(--ink); }
.steps li.done::before { background: var(--brasa); }
.step-dot { flex: none; width: 14px; height: 14px; border-radius: 50%; border: 2px solid var(--line); background: #fff; }
.steps li.done .step-dot { border-color: var(--brasa); background: var(--brasa); }
.steps li[aria-current="step"] .step-dot { box-shadow: 0 0 0 4px rgba(255, 107, 26, 0.2); }
.step-title { flex: 1; font-weight: 600; }
.step-time { font-variant-numeric: tabular-nums; font-size: 13px; }

.btn-emergency {
  flex: none; height: 52px; border-radius: 18px; border: 1.5px solid var(--bad-dot); color: var(--bad); font-weight: 600; font-size: 15px; text-decoration: none;
  display: flex; align-items: center; justify-content: center;
}
.foot { text-align: center; font-size: 12px; color: var(--muted); }

.message { margin: auto; padding: 40px 24px; max-width: 420px; display: flex; flex-direction: column; align-items: center; gap: 12px; text-align: center; }
.message h1 { margin: 0; font-family: "Sora", sans-serif; font-size: 22px; letter-spacing: -0.02em; }
.message p { margin: 0 0 12px; color: var(--muted); line-height: 1.5; }
.message .btn-emergency { width: 100%; }
.message-icon { width: 60px; height: 60px; border-radius: 50%; background: var(--warn-bg); color: var(--warn); display: grid; place-items: center; }
.message-icon.ended { background: var(--chip); color: var(--ink-2); }

.skeleton { border-radius: 14px; background: linear-gradient(90deg, #f6f3ef, #ece7e1, #f6f3ef); background-size: 200% 100%; animation: shimmer 1.4s infinite; }
@keyframes shimmer { to { background-position: -200% 0; } }
@keyframes live { 50% { opacity: 0.35; } }
@keyframes ping { 0% { transform: scale(0.6); opacity: 0.7; } 100% { transform: scale(2.2); opacity: 0; } }
@media (prefers-reduced-motion: reduce) { *, *::before { animation: none !important; transition: none !important; } }
